export default __webpack_public_path__ + "static/media/pink-ship.1a6bd74b.png";